import VoucherInformation from './VoucherInformation';

export default VoucherInformation;
